import Swiper from 'swiper';

import { track } from '../utils/tracking';

class PlanQuiz extends HTMLElement {
  constructor() {
    super();

    // Setup elements
    this.questionsWrap = this.querySelector('[data-questions-wrap]');
    this.questions = this.querySelectorAll('plan-quiz-question');
    this.results = this.querySelector('plan-quiz-results');
    this.slides = this.querySelectorAll('[data-slide]');
    this.backBtn = this.querySelectorAll('[data-back]');
    this.nextBtn = this.querySelectorAll('[data-next]');
    this.progressBar = this.querySelector('[data-progress-bar]');
    this.progressText = this.querySelector('[data-progress-text]');

    // Initialize swiper
    this.swiper = new Swiper(this.questionsWrap, {
      spaceBetween: 80,
      slidesPerView: 1,
      allowTouchMove: false,
      preventClicks: false,
      a11y: {
        enabled: false,
      },
      on: {
        afterInit: this.manageFocus.bind(this),
        activeIndexChange: this.manageFocus.bind(this),
        slidesUpdated: this.manageFocus.bind(this),
        slideChange: this.handleSlideChange.bind(this),
      },
    });

    // Bind event handlers
    this.backBtn.forEach((btn) => btn.addEventListener('click', this.handleBack.bind(this)));
    this.nextBtn.forEach((btn) => btn.addEventListener('click', this.handleNext.bind(this)));
    this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
  }

  handleBlockSelect(e) {
    const index = [...this.slides].indexOf(e.target);
    this.swiper.slideTo(index);
  }

  handleSlideChange() {
    const { activeIndex, slides } = this.swiper;
    const totalSlides = slides.length;
    this.updateProgress(activeIndex, totalSlides);

    if (activeIndex === totalSlides - 1) {
      this.updateResults();
    }
  }

  updateResults() {
    const usage = [...this.questions].reduce((acc, question) => {
      return acc + parseInt(question.selectedOption, 10);
    }, 0);

    this.results.update(usage);
  }

  updateProgress(activeIndex, totalSlides) {
    const progress = ((activeIndex + 1) / totalSlides) * 100;
    const isLastSlide = activeIndex === totalSlides - 1;

    // Skip the return to the first
    if (activeIndex > 0) {
      track(`quiz_progress_${activeIndex}`); // finished step index
    }

    if (isLastSlide) {
      track('quiz_completed');
    }

    this.progressBar.style.maxWidth = `${progress}%`;
    this.progressText.textContent = isLastSlide ? 'Done!' : `${progress.toFixed(0)}% Finished`;
  }

  handleBack() {
    this.swiper.slidePrev();
  }

  handleNext() {
    this.swiper.slideNext();
  }

  reset() {
    this.swiper.slideTo(0);
    this.progressBar.style.maxWidth = '';
    this.progressText.innerHTML = this.progressText.dataset.default;

    this.questions.forEach((question) => {
      question.reset();
    });
  }

  manageFocus(swiper) {
    swiper.slides.forEach((slide, index) => {
      const focusableElements = slide.querySelectorAll('button, a, input');
      const isActiveSlide = swiper.activeIndex === index;
      focusableElements.forEach((el) => {
        el.tabIndex = isActiveSlide ? 0 : -1;
      });
    });
  }
}

customElements.define('plan-quiz', PlanQuiz);
